import React from "react";
import { Typography, Card, Row, Layout, Tag, Col, Badge } from "antd";
import { typoColors } from "../../components/plannings/planningData";
import { useHistory } from "react-router-dom";
import { Buffer } from "buffer";

const { Title, Text } = Typography;
// const { Meta } = Card;
const { Content } = Layout;

const LogementsList = ({ housings }) => {
  let history = useHistory();
  const selectHousing = (housingName, housingId, programName, programId) => {
    localStorage.setItem("currentHousing", housingName);
    localStorage.setItem("currentHousingId", housingId);
    localStorage.setItem("currentProgram", programName);
    localStorage.setItem("currentProgramId", programId);

    history.push("/logement/" + housingId);
  };

  return (
    <div>
      {housings.map((x, idx) => {
        const strImgData = x.program.avatar
          ? "data:image/png;base64," +
            new Buffer(x.program.avatar.data).toString("base64")
          : "data:image/png;base64,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";

        return (
          <div key={x._id}>
            <Content
              style={{
                margin: "24px 24px 0px 24px",
                padding: 0,
                // minHeight: 280,
              }}
            >
              {x.notifications.length > 0 ? (
                <Badge.Ribbon
                  text={
                    x.notifications.length === 1 ? (
                      "1 nouvelle notification"
                    ) : (
                      <div>
                        {x.notifications.length + " nouvelles notifications"}
                      </div>
                    )
                  }
                >
                  <Card
                    hoverable
                    title={x.program.name}
                    bordered={false}
                    style={{ width: "100%" }}
                    onClick={() =>
                      selectHousing(
                        x.lotcomm,
                        x._id,
                        x.program.name,
                        x.program._id
                      )
                    }
                  >
                    <Row>
                      <Col span={4}>
                        <img
                          width="90%"
                          heigth="32px"
                          // width="64px"
                          // height="100%"
                          src={strImgData}
                          alt="promoteur"
                        />
                      </Col>
                      <Col span={20}>
                        <Title level={5}>Lot : {x.lotcomm}</Title>
                        <br />
                        <p>
                          <Tag
                            color={typoColors[x.typologie.toLowerCase()]}
                            style={{ fontSize: "16px", padding: "5px" }}
                          >
                            {x.typologie.toUpperCase()}
                          </Tag>
                          Batiment : {x.batiment}
                        </p>
                        <p>
                          <Text type="secondary">
                            {x.program.adressenumero +
                              " " +
                              x.program.adresserue +
                              " " +
                              x.program.adressecodepostal +
                              " " +
                              x.program.adresseville}
                          </Text>
                        </p>
                      </Col>
                    </Row>
                  </Card>
                </Badge.Ribbon>
              ) : (
                <Card
                  hoverable
                  title={x.program.name}
                  bordered={false}
                  style={{ width: "100%" }}
                  onClick={() =>
                    selectHousing(
                      x.lotcomm,
                      x._id,
                      x.program.name,
                      x.program._id
                    )
                  }
                >
                  <Row>
                    <Col span={4}>
                      <img
                        alt="Promoteur"
                        width="90%"
                        heigth="32px"
                        // width="64px"
                        // height="100%"
                        src={strImgData}
                      />
                    </Col>
                    <Col span={20}>
                      <Title level={5}>Lot : {x.lotcomm}</Title>
                      <br />
                      <p>
                        <Tag
                          color={typoColors[x.typologie.toLowerCase()]}
                          style={{ fontSize: "16px", padding: "5px" }}
                        >
                          {x.typologie.toUpperCase()}
                        </Tag>
                        Batiment : {x.batiment}
                      </p>
                      <p>
                        <Text type="secondary">
                          {x.program.adressenumero +
                            " " +
                            x.program.adresserue +
                            " " +
                            x.program.adressecodepostal +
                            " " +
                            x.program.adresseville}
                        </Text>
                      </p>
                    </Col>
                  </Row>
                </Card>
              )}
            </Content>
            {/*<Link to={"/logement/" + x._id}>
              <div key={"progImg-" + idx}>
                <Divider />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Space direction="horizontal">
                    <img
                      width="64px"
                      height="100%"
                      src={
                        "data:image/png;base64," +
                        new Buffer(x.program.avatar.data).toString("base64")
                      }
                    />
                    {x.lotcomm} (Programme: {JSON.stringify(x.program.name)},
                    Promoteur: {JSON.stringify(x.program.promotername)},
                    Typologie: {x.typologie}, Batiment: {x.batiment}) NOTIF :{" "}
                    {JSON.stringify(x.notifications)}
                  </Space>
                </div>
                <Divider />
              </div>
                    </Link>*/}
          </div>
        );
      })}
    </div>
  );
};

export default LogementsList;
